import { EVENT_TYPE_FILTER } from '../../../../constants/events'

export const progressInitialState = {
  carSelectionCount: 0, // Подбор авто
  carSelectionCount2: 0, // Выбор авто
  demonstrationCount: 0,
  carChoiceCount: 0,
  carRegistrationCount: 0
}

export const filterInitialState = {
  id: '',
  eventId: '',
  statusCodes: [],

  dateType: 'created',
  dateFrom: null,
  dateTo: null,

  saleType: undefined,
  paymentType: undefined,
  creationType: undefined,

  trade: false,
  ropCheck: false,
  ropCheckFalse: false,

  vin: undefined,
  marka: undefined,
  model: undefined,

  phoneNumber: undefined,
  firstName: undefined,
  lastName: undefined,
  iin: undefined
}

export const paginationInitialState = {
  limit: 10,
  offset: 0,
  count: 0
}

export const tasksInitalState = {
  dealId: undefined,
  completed: 'open',
  statusCodes: EVENT_TYPE_FILTER.map(e => e.code),
  firstName: undefined,
  phoneNumber: undefined,
  startDate: null,
  endDate: null
}
